// Rozwijanie tekstu SEO w sekcji home-faq-seo ("Czytaj więcej" / "Zwiń").
(() => {
  document.querySelectorAll('[data-iwc-sf-toggle]').forEach((btn) => {
    const box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box || btn.dataset.bound) return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;

      if (!open) {
        const top = box.parentNode.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });
})();
